import ApiService from '@/common/ApiService/ApiService';
import StatusObject from '@/common/ApiService/StatusObject';
import { HttpVerb } from '@/common/ApiService/HttpVerb';

import { BrochureRequestFormModel } from './BrochureRequestForm/BrochureRequestForm.types';
import { InterestsFormModel } from './InterestsForm/InterestsForm.types';

export const submitBrochureRequest = async (
  model: BrochureRequestFormModel,
  countryId: number,
  isBtB: boolean = false,
): Promise<StatusObject> => {
  let serviceName = isBtB ? 'TravelAgentsService' : 'MarketingMaterialsApiService';
  const brochureService = new ApiService(`/api/${serviceName}/`, {
    returnData: true,
  });
  let result: StatusObject = {
    IsOk: true,
    Error: '',
  };

  result.Item = await brochureService
    .call(
      'OrderBrochure',
      { CountryId: countryId, ...model, IsBtB: isBtB },
      {
        verb: HttpVerb.POST,
      },
    )
    .catch((err) => {
      //console.log('Server failed, ', err);
      result.IsOk = false;
      let errMsg = err?.response?.data?.Data?.Error ?? err?.request?.response;
      result.Error = errMsg ?? err;
    });
  return result;
};

export const getInterests = async (countryId: number): Promise<StatusObject> => {
  const brochureService = new ApiService('/api/MarketingMaterialsApiService/', {
    returnData: true,
  });
  let result: StatusObject = {
    IsOk: true,
    Error: '',
  };
  result.Item = await brochureService
    .call(`GetQuestionsList?countryId=${countryId}`, {
      verb: HttpVerb.GET,
    })
    .catch((err) => {
      //console.log('Server failed, ', err);
      result.IsOk = false;
      result.Error = err?.request?.response ?? err;
    });
  return result;
};

export const submitInterestsRequest = async (
  brochureId: number,
  model: InterestsFormModel,
): Promise<StatusObject> => {
  const brochureService = new ApiService('/api/MarketingMaterialsApiService/', {
    returnData: true,
  });
  let result: StatusObject = {
    IsOk: true,
    Error: '',
  };
  result.Item = await brochureService
    .call(
      'UpdateAnswerQuestions',
      { BrochureId: brochureId, ...model },
      {
        verb: HttpVerb.PUT,
      },
    )
    .catch((err) => {
      //console.log('Server failed, ', err);
      result.IsOk = false;
      result.Error = err?.request?.response ?? err;
    });
  return result;
};
